import PropTypes from 'prop-types';
import {Legend, LegendHeader} from '../atoms/Legend';

import './style.scss';

const SpecificLegendContent = ({children}) => {
	return <div className="insar-SpecificLegend-content">{children}</div>;
};

SpecificLegendContent.propTypes = {
	children: PropTypes.node,
};

const SpecificLegendItem = ({iconSize, title}) => {
	return (
		<div className="insar-SpecificLegendItem">
			<div
				className="insar-SpecificLegendItem-icon"
				style={{
					width: `${iconSize}rem`,
					height: `${iconSize}rem`,
					borderRadius: `${iconSize / 2}rem`,
				}}
			/>
			<div className="insar-SpecificLegendItem-title">{title}</div>
		</div>
	);
};

SpecificLegendItem.propTypes = {
	iconSize: PropTypes.number,
	title: PropTypes.string,
};

const ReliabilityLegend = () => {
	return (
		<Legend>
			<LegendHeader title="Reliability of the estimated displacement" />
			<SpecificLegendContent>
				<SpecificLegendItem iconSize={0.8} title="Reliable" />
				<SpecificLegendItem iconSize={0.4} title="Unreliable" />
			</SpecificLegendContent>
		</Legend>
	);
};

const SensitivityLegend = () => {
	return (
		<Legend>
			<LegendHeader title="Radar sensitivity" />
			<SpecificLegendContent>
				<SpecificLegendItem iconSize={0.8} title="Reliable" />
				<SpecificLegendItem iconSize={0.4} title="Unreliable" />
			</SpecificLegendContent>
		</Legend>
	);
};

export const SpecificAttributeLegend = ({attributeKey}) => {
	if (attributeKey === 'coh') {
		return <ReliabilityLegend />;
	} else if (attributeKey === 'sens') {
		return <SensitivityLegend />;
	} else {
		return null;
	}
};

SpecificAttributeLegend.propTypes = {
	attributeKey: PropTypes.string,
};

export const GradientBarLegend = ({colors, labels}) => {
	const style = {
		background: `linear-gradient(90deg, ${colors.join(',')})`,
	};

	return (
		<>
			<div className="insar-GradientBarLegend-rail" style={style} />
			<div className="insar-GradientBarLegend-labels">
				{labels?.map((label, i) => (
					<span key={i}>{label}</span>
				))}
			</div>
		</>
	);
};

GradientBarLegend.propTypes = {
	colors: PropTypes.array,
	labels: PropTypes.array,
};

export const Triangle = ({size, color, rotate}) => {
	const s = size || 10;
	const p = 1;
	const transformation = rotate
		? `rotate(${rotate} ${size / 2 + p} ${size / 2 + p})`
		: '';

	return (
		<svg className="insar-Triangle" height={s + 2 * p} width={s + 2 * p}>
			<polygon
				fill={color}
				points={`${s / 2 + 1},1 1,${s + 1} ${s + 1},${s + 1}`}
				className="triangle"
				transform={transformation}
			/>
		</svg>
	);
};

Triangle.propTypes = {
	size: PropTypes.number,
	color: PropTypes.string,
	rotate: PropTypes.number,
};
